var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasStats)?_c('div',{staticClass:"re-shop-products-pagination-status"},[(!_vm.stats.from)?[_vm._v(_vm._s(_vm.$$templify(_vm.$$pt('pagination.status.label', 'No result'), _vm.stats, ['{', '}'])))]:[_vm._v(_vm._s(_vm.$$templify(_vm.$$pt('pagination.status.label', 'Showing {from}-{to} of {total} results'), _vm.stats, ['{', '}'])))]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }